import React, { useEffect } from 'react';
import './title-header.css';
import styles from '../../Pronto360.module.css'
// Remove Link import if not used elsewhere in this file for the non-showGoBackBtn case
// import { Link, useNavigate } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'; // Keep useNavigate
import UtilService from '../../../services/UtilService';

interface TitleHeaderProps {
  title: string | null | undefined;
  subtitle: string | null | undefined;
  description: string | null | undefined;
  showGoBackBtn?: boolean;
  forceTarget?: string | null | undefined;
}

const TitleSubtitleBlock: React.FC<any> = ({ title, subtitle }) => {
  // ... (implementation as before)
  return (
    <>
      {UtilService.isEmpty(subtitle) && (
        <div className="m-auto text-center m-4">
          <div className="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      {!UtilService.isEmpty(subtitle) && (
        <div className="">
          <h6 className="mb-1 tx-12 ">{String(title)?.toUpperCase()}</h6>
          <div className="d-flex">
            <h4 className="tx-16 font-weight-semibold mb-2 main-color-pronto">
              {subtitle ? subtitle?.toUpperCase() : ''}
            </h4>
          </div>
        </div>
      )}
    </>)
}


const TitleHeader: React.FC<TitleHeaderProps> = ({ title, subtitle, description, showGoBackBtn, forceTarget }) => {
  const navigate = useNavigate();

  const handleGoBackHistory = () => {
    if (forceTarget) {
      if (forceTarget.startsWith('http://') || forceTarget.startsWith('https://')) {
        window.location.href = forceTarget;
      } else {
        navigate(forceTarget); // Navigate internally
      }
    } else {
      navigate(-1); // Go back in history
    }
  };

  useEffect(() => { goToTop() }, [])

  const goToTop = () => {
    UtilService.screenup();
  }

  return (
    <div className="sales-card border-bottom w-100 omit">
      <div className="ps-3 pt-4 pe-2 pb-2">
        {showGoBackBtn ? (
          // Use a standard <a> tag and prevent its default behavior
          <a
            href="#" // Keep href for semantics/accessibility if desired
            onClick={(e) => {
              e.preventDefault(); // *** Prevent default anchor navigation ***
              handleGoBackHistory();
            }}
            className="d-flex align-items-center border-0"
            style={{ textDecoration: 'none', color: 'inherit' }} // Prevent underline, inherit color
          >
            <i className="fe fe-arrow-left me-2 p-2 border-primary bg-dark text-primary align-start rounded-circle w-33 omit"></i>{" "}
            <TitleSubtitleBlock title={title} subtitle={subtitle} />
          </a>
        ) : (
          // Option 1: Keep Link if it navigates somewhere else
          // Option 2: Use <a> or <div> if it doesn't navigate
          <div // Or <a> if it should look like a link but do nothing/something else
            className="d-flex align-items-center border-0 "
          >
            <i className="fe fe-info me-2 p-2 border-primary bg-dark text-primary align-start rounded-circle w-33"></i>{" "}
            <TitleSubtitleBlock title={String(title)?.toUpperCase()} subtitle={subtitle?.toUpperCase()} />
          </div>
        )}
        <div className="pb-0 mt-0 print-buttons">
          <p className={`mb-0 tx-12 text-muted ${styles.maxContent} w-100`}>
            {!UtilService.isEmpty(description) ? (
              <>
                {description}
                <i className="fa fa-caret-down mx-2 text-success"></i>
              </>
            ) : (
              <>&nbsp;</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TitleHeader;

